module.exports = __webpack_public_path__ + "media/images/desenvolvimento3-e3138fa4c619e8c3959ebc2dcef542f8.jpg";